import Swiper from 'swiper';

export default {
    init() {
      // JavaScript to be fired on the home page
        (function () {
            if ($('#events-slider').length) {
                var mySwiper = new Swiper('#events-slider .swiper-container', {
                    slidesPerView: 'auto',
                    spaceBetween: 1,
                    navigation: {
                        nextEl: '.slider-button-next',
                        prevEl: '.slider-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination-box',
                        type: 'fraction',
                    },
                });

                mySwiper.init();
            }
        })();
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js